import React, { useEffect, useState } from 'react'
import ImageView from './MessageImage'

import { Message } from 'types/dataManagement'

import { isJsonString, getMediaAttachmentType } from 'utils/dataParsing'
import dayjs from 'dayjs'

interface IMessageMediaProps {
    messageItem: Message
    messageId: number
    mediaList?: string[]
    viewLimit: number
    customClass?: string
    olrsBasicData: any
    highlightWords?: {
        anchorKeywords: string[]
        contextWords: string[]
        smartBarKeywords: string[]
    }
    isOnlyFirst?: boolean
}

interface IMediaInfo {
    url: string
    source: string
    itemOlrData: any
    isOlrImage: boolean
}

const MessageMedia = (props: IMessageMediaProps) => {
    const {
        messageItem,
        messageId,
        mediaList,
        viewLimit,
        customClass,
        highlightWords,
        olrsBasicData,
        isOnlyFirst,
    } = props
    const [imagesInfoList, setImagesInfoList] = useState<IMediaInfo[] | null>(
        null
    )
    const [imagesLoaded, setImagesLoded] = useState<number[]>([])
    const [imagesViewLimit, setImagesLimit] = useState(5)
    const nonProxySources = ['procherk.info']
    const proxyPrefix = '/api/getimage?url='

    useEffect(() => {
        if (messageId) {
            setImagesLimit(viewLimit)
            setImagesLoded([])
            prepareImagesToView()
        }
    }, [messageId])

    const prepareImagesToView = () => {
        let clearedMediaList = []
        let olrItemUrls: any = []
        let olrsData: any = []

        if (
            messageItem &&
            messageItem.source === 'tiktok.com' &&
            messageItem.objectType === 4
        ) {
            setImagesInfoList([])
            return
        }

        if (messageItem && messageItem.attachmentUrls) {
            clearedMediaList = messageItem.attachmentUrls.filter(
                (img) => !img.includes('.svg')
            )
            const olrDetails =
                messageItem.olrDetails && isJsonString(messageItem.olrDetails)
                    ? JSON.parse(messageItem.olrDetails)
                    : null
            const olrsArr = messageItem.olrs || []

            if (olrDetails) {
                for (let key in olrDetails) {
                    if (olrsArr.some((el) => el === key)) {
                        let urls = olrDetails[key].map((el: any) => el.url)
                        olrItemUrls = [...olrItemUrls, ...urls]

                        //prepare olrs data with object names
                        if (olrsBasicData) {
                            let findOrigin = olrsBasicData.find((el: any) => {
                                return el.key == key
                            })

                            if (findOrigin) {
                                const olrDataObj = {
                                    ...findOrigin,
                                    imagesUrls: urls,
                                }

                                olrsData.push(olrDataObj)
                            }
                        }
                    }
                }
            }
        } else {
            clearedMediaList = mediaList ? [...mediaList] : []
        }

        const imagesInfo: any = clearedMediaList.map((el) => {
            const isOlrImage = olrItemUrls.includes(el)
            const itemOlrData = olrsData.filter((o: any) => {
                return o.imagesUrls.includes(el)
            })

            return {
                url: el,
                source: messageItem?.source ? messageItem?.source : null,
                itemOlrData: itemOlrData,
                isOlrImage,
            }
        })

        setImagesInfoList(imagesInfo)
    }

    const getVideoDuration = (source: string, duration: string) => {
        let durationToView = null
        let videoDuration = duration ? parseInt(duration) : 0
        let messageSource = source

        if (messageSource == 'youtube.com') {
            const duration = dayjs().startOf('day').second(videoDuration)
            const hours = duration.hour()

            durationToView =
                hours > 0
                    ? duration.format('H:mm:ss')
                    : duration.format('mm:ss')
        }

        return durationToView
    }

    const setViewAllImages = (limit: number) => {
        setImagesLimit(limit)
    }

    const handleImageLoad = (success: boolean, i: number) => {
        if (success) {
            setImagesLoded((prev) => [...prev, i])
        }
    }

    return (
        <div
            className={`flex flex-wrap gap-2 ${customClass || ''} items-baseline w-full relative`}
            id={(messageId || messageItem.id) + '_images'}
        >
            {imagesInfoList
                ? imagesInfoList
                      .slice(0, imagesViewLimit)
                      .map((image, i) =>
                          getMediaAttachmentType(image.url, image.source) ===
                          'image' ? (
                              <>
                                  {messageItem.source !== 'youtube.com' ? (
                                      <ImageView
                                          key={
                                              'msg_' +
                                              (messageId || messageItem.id) +
                                              '_image_' +
                                              i
                                          }
                                          src={image.url}
                                          enclosureText={
                                              messageItem?.enclosureText
                                                  ? (messageItem.enclosureText as any)
                                                  : null
                                          }
                                          objectType={messageItem.objectType}
                                          mediaType={messageItem.mediaType}
                                          olrDetails={image.itemOlrData}
                                          highlightWords={highlightWords}
                                          originalSrc={image.url}
                                          customClass={`image-item ${messageItem.objectType === 10 && messageItem.mediaType === 44 ? 'max-w-[400px] max-h-[900px]' : 'w-[100px] max-h-[100px]'}`}
                                          onSelectImage={() => {}}
                                          messageID={messageId}
                                          videoDuration={
                                              image.source &&
                                              image.source == 'youtube.com' &&
                                              messageItem.objectType === 4
                                                  ? getVideoDuration(
                                                        image.source,
                                                        messageItem.videoDuration
                                                    )
                                                  : null
                                          }
                                          isOlrItem={image.isOlrImage}
                                          onLoaded={(success: boolean) =>
                                              handleImageLoad(success, i)
                                          }
                                      />
                                  ) : null}
                              </>
                          ) : null
                      )
                : null}
            {imagesInfoList &&
            imagesInfoList.length > imagesViewLimit &&
            imagesLoaded.length &&
            !isOnlyFirst ? (
                <span
                    className="text-[#01928D] underline decoration-dotted underline-offset-4 hover:text-gold cursor-pointer"
                    onClick={(e) => setViewAllImages(imagesInfoList.length)}
                >
                    Show More
                </span>
            ) : null}
        </div>
    )
}

export default MessageMedia
